/**
 * Category Page Script
 * @description Script para página de categoria
 * @version 1.0.0
 * @author Irroba Platform
 */

// Importar módulos globais comuns
import LazyLoading from '../functions/lazy-loading.js';
import { generateTemplateContent, parseToHtml, replaceString } from '../functions/html_element.js';
import { setCacheData, getCacheData } from '../functions/cache.js';
import { initGlobalComponents } from '../modules/global-components.js';
import { initProductListsNearViewport } from '../modules/product_list_module.js';

/**
 * Inicialização da página de categoria
 */
const initCategoryPage = () => {
    try {
        // Inicializar componentes comuns
        initGlobalComponents();
        initProductListsNearViewport();
        initLazyLoading();

        // Funcionalidades específicas da categoria
        initFilters();
        initSorting();
        initPagination();
        initGridToggle();
    } catch (error) {
        console.error('❌ Erro ao inicializar página de categoria:', error);
    }
};

/**
 * Inicializa Lazy Loading de imagens
 */
const initLazyLoading = () => {
    try {
        new LazyLoading({
            selector: 'img[data-src]',
            rootMargin: '50px'
        });
    } catch (error) {
        console.warn('Erro ao inicializar Lazy Loading:', error);
    }
};

/**
 * Inicializa sistema de filtros
 */
const initFilters = () => {
    const filterToggles = document.querySelectorAll('[data-filter-toggle]');

    filterToggles.forEach(toggle => {
        toggle.addEventListener('click', function () {
            const filterPanel = document.querySelector('[data-filter-panel]');
            if (filterPanel) {
                filterPanel.classList.toggle('active');
            }
        });
    });

    // Aplicar filtros
    const filterInputs = document.querySelectorAll('[data-filter-input]');
    filterInputs.forEach(input => {
        input.addEventListener('change', function () {
            // Implementar lógica de aplicação de filtro
        });
    });
};

/**
 * Inicializa sistema de ordenação
 */
const initSorting = () => {
    const sortSelect = document.querySelector('[data-sort-select]');

    if (sortSelect) {
        sortSelect.addEventListener('change', function () {
            const sortValue = this.value;
            // Implementar lógica de ordenação
        });
    }
};

/**
 * Inicializa paginação
 */
const initPagination = () => {
    const paginationLinks = document.querySelectorAll('[data-pagination-link]');

    paginationLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            const page = this.dataset.paginationLink;
            // Ajax pagination pode ser implementado aqui
        });
    });
};

/**
 * Inicializa toggle de visualização (grid/list)
 */
const initGridToggle = () => {
    const gridBtn = document.querySelector('[data-view="grid"]');
    const listBtn = document.querySelector('[data-view="list"]');
    const productContainer = document.querySelector('[data-products-container]');

    if (gridBtn && productContainer) {
        gridBtn.addEventListener('click', function () {
            productContainer.classList.remove('view-list');
            productContainer.classList.add('view-grid');
            gridBtn.classList.add('active');
            listBtn?.classList.remove('active');
        });
    }

    if (listBtn && productContainer) {
        listBtn.addEventListener('click', function () {
            productContainer.classList.remove('view-grid');
            productContainer.classList.add('view-list');
            listBtn.classList.add('active');
            gridBtn?.classList.remove('active');
        });
    }
};

/**
 * Inicializa quando o DOM estiver pronto
 */
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCategoryPage);
} else {
    initCategoryPage();
}

export default {
    init: initCategoryPage
};
